export default function priceListWidget(editor) {
  editor.DomComponents.addType('eb-price-list', {
    isComponent(el) {
      return el.getAttribute && el.getAttribute('data-gjs-type') === 'eb-price-list'
    },
    model: {
      defaults: {
        name: 'Price List',
        tagName: 'div',
        droppable: false,
        attributes: { 'data-gjs-type': 'eb-price-list' },
        style: {
          'padding': '20px',
          'max-width': '600px',
        },
        components: `
          <div style="display:flex;justify-content:space-between;align-items:flex-start;padding:16px 0;border-bottom:1px dashed #ddd;">
            <div style="flex:1;">
              <h4 style="font-size:16px;font-weight:600;color:#333;margin:0 0 4px;">Premium Package</h4>
              <p style="font-size:13px;color:#888;margin:0;">Full access to all features and priority support</p>
            </div>
            <span style="font-size:18px;font-weight:700;color:#667eea;white-space:nowrap;margin-left:20px;">$99</span>
          </div>
          <div style="display:flex;justify-content:space-between;align-items:flex-start;padding:16px 0;border-bottom:1px dashed #ddd;">
            <div style="flex:1;">
              <h4 style="font-size:16px;font-weight:600;color:#333;margin:0 0 4px;">Standard Package</h4>
              <p style="font-size:13px;color:#888;margin:0;">Core features with email support</p>
            </div>
            <span style="font-size:18px;font-weight:700;color:#667eea;white-space:nowrap;margin-left:20px;">$49</span>
          </div>
          <div style="display:flex;justify-content:space-between;align-items:flex-start;padding:16px 0;">
            <div style="flex:1;">
              <h4 style="font-size:16px;font-weight:600;color:#333;margin:0 0 4px;">Basic Package</h4>
              <p style="font-size:13px;color:#888;margin:0;">Essential features to get started</p>
            </div>
            <span style="font-size:18px;font-weight:700;color:#667eea;white-space:nowrap;margin-left:20px;">$19</span>
          </div>
        `,
        traits: [],
      },
    },
  })

  editor.BlockManager.add('eb-price-list', {
    label: 'Price List',
    category: 'Pro',
    media: '<svg viewBox="0 0 24 24"><path fill="currentColor" d="M3,4H7V8H3V4M9,5V7H21V5H9M3,10H7V14H3V10M9,11V13H21V11H9M3,16H7V20H3V16M9,17V19H21V17H9Z"/></svg>',
    content: { type: 'eb-price-list' },
  })
}
